class StorageHelper {
    constructor() {
        this.storage = window.localStorage;
        // TODO maybe use this for mercnet stuff
        //this.sessionStorage = window.sessionStorage;
    }

    getListView = () => {
        return this.storage.getItem('ListView') || 'large';
    }

    setListView = (viewMode) => {
        this.storage.setItem('ListView', viewMode);
    }

    getDetailsTextOnly = () => {
        return this.storage.getItem('DetailsTextOnly') === 'true';
    }

    setDetailsTextOnly = (textOnly) => {
        this.storage.setItem('DetailsTextOnly', textOnly.toString());
    }

    getPersistedPath = () => {
        return this.storage.getItem('PersistedPath') || ''
    }

    setPersistedPath = (path) => {
        this.storage.setItem('PersistedPath', path);
    }

    getActivationKey = () => {
        return this.storage.getItem('ActivationKey') || ''
    }

    setActivationKey = (activationKey) => {
        this.storage.setItem('ActivationKey', activationKey);
    }

    setMercNetDealer = (dealer) => {
        this.storage.setItem('MercNetDealer', dealer);
    }

    getMercNetDealer = () => {
        return this.storage.getItem('MercNetDealer') || '';
    }

    setMercNetLanguage = (language) => {
        this.storage.setItem('MercNetLanguage', language);
    }

    getMercNetLanguage = () => {
        return this.storage.getItem('MercNetLanguage') || '';
    }
}


export const storageHelper = new StorageHelper();